module.exports = __webpack_public_path__ + "img/search-solid.1f650902.svg";